export function parseDate(date: string) {
    const [year, month, day] = date.split('-')
    return day ? day + '/' + month + '/' + year : null
}

export function parseDateTime(datetime: string) {
    const [date, time] = datetime.split(' ')
    const [year, month, day] = date.split('-')
    return day ? `${day}/${month}/${year} ${time}` : null
}

export function parseDDMMYYYY(dateString: string) {
    if (!dateString) return null;
    const parts = dateString.split('/'); // Divide a string em dia, mês e ano
    if (parts.length === 3) {
        // Date constructor: new Date(year, monthIndex, day)
        // O mês é 0-indexed, então subtraímos 1
        return new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
    }
    return null; // Retorna null se o formato não for o esperado
}
